import { useContext } from "react";
import { WhatsAppContext, IWhatsAppContextValue } from "./WhatsApp.context";

export const useWhatsApp = (): IWhatsAppContextValue => {
  const context = useContext(WhatsAppContext);
  if (!context) {
    throw new Error("useWhatsApp must be used within a WhatsAppProvider");
  }
  return context;
};
